mutation UpdateContract($id: ID!, $input: UpdateContractInput!) {
  updateContract(id: $id, input: $input) {
    id
    title
    status
  }
}
